import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { ListWithDetailLayout } from '@sorare/core/src/components/layout/ListWithDetailLayout';

import { JoinSquad } from 'components/rivals/squads/JoinSquad';

const CreateSquadLayout = () => {
  return (
    <ListWithDetailLayout>
      <FullWidthContainer.NoPadding>
        <JoinSquad />
      </FullWidthContainer.NoPadding>
    </ListWithDetailLayout>
  );
};
export default CreateSquadLayout;
